// AI transcription block removed in ofuro-wiki
import type { BlockModel } from '@blocksuite/affine/store';

export const TranscriptionBlock = (_props: { block: BlockModel }) => {
  return null;
};
